// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { IntegrationTile } from '@/components/greenlight/IntegrationTile';

// Integration logo stack — renders up to 3 IntegrationTiles with a "+k" overflow
// chip. Falls back to nothing when no integrations are present.
export function IntegrationStack({ slugs }: { slugs: string[] }): React.JSX.Element | null {
  if (slugs.length === 0) return null;
  const visible = slugs.slice(0, 3);
  const overflow = slugs.length - visible.length;
  return (
    <div className="flex items-center gap-1" aria-hidden="true">
      {visible.map((slug) => (
        <IntegrationTile key={slug} slug={slug} displayName={slug} size={22} />
      ))}
      {overflow > 0 && (
        <span className="inline-flex size-[22px] items-center justify-center rounded-gl border border-border bg-muted font-mono text-[10px] text-foreground">
          +{overflow}
        </span>
      )}
    </div>
  );
}
